<template>
  <the-dialog-box
    ref="dialogBox"
    :is-submit-btn="!isView"
    :submit="submit"
    :submit-btn-text="'Submit'"
    :full-screen="true"
    :persistent="true"
  >
    <template slot="header">
      <span>Installation Material</span>
    </template>
    <template slot="body">
      <v-row v-if="!isView && !isActive">
        <v-spacer />
        <v-col class="text-end">
          <v-btn color="primary" outlined @click="add">
            <v-icon small class="mr-1"> fas fa-plus </v-icon>
            New Item
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col :class="`${isView || item.is_active === 1 ? '' : 'pt-0'}`">
          <v-card elevation="0" outlined>
            <v-data-table
              :headers="headers"
              :items="item.items"
              hide-default-footer
              disable-pagination
              dense
              item-key="inventory_tag"
              :loading="loading"
            >
              <template #[`item.status`]="{ item }">
                <v-chip
                  v-if="item.status"
                  class="mt-1 mb-1 mr-3"
                  small
                  text-color="white"
                  style="cursor: pointer"
                  :color="item.status ? item.status.color : ''"
                >
                  {{ item.status ? item.status.name : '' }}
                </v-chip>
              </template>
              <template #[`item.actions`]="{ item }">
                <v-btn
                  v-if="!isView && !isActive"
                  class="ml-1 mt-1 mb-1"
                  color="primary"
                  outlined
                  small
                  @click="openEditItem(item.inventory_tag)"
                >
                  EDIT
                </v-btn>
                <v-btn
                  v-if="!isView && !isActive"
                  class="ml-1 mt-1 mb-1"
                  color="error"
                  outlined
                  small
                  @click="deleteItem(item)"
                >
                  DELETE
                </v-btn>
              </template>
              <template slot="body.append">
                <tr>
                  <th />
                  <th />
                  <th>
                    <span
                      :style="{
                        color: isDarkMode ? '' : '#000000',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }"
                      >Totals:</span
                    >
                  </th>
                  <th>
                    <span
                      :style="{
                        color: isDarkMode ? '' : '#000000',
                        fontWeight: 'bold',
                        fontSize: '14px',
                      }"
                      style="color: #000000; font-weight: bold; font-size: 14px"
                      >{{ getTotalRequired() }}</span
                    >
                  </th>
                  <th>
                    <span
                      :style="{ color: isDarkMode ? '' : '#000000', fontWeight: 'bold', fontSize: '14px' }"
                      style="color: #000000; font-weight: bold; font-size: 14px;"
                    >{{ getTotalSupplied() }}</span>
                  </th>
                  <th />
                  <th />
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
      <v-spacer />
      <v-row>
        <v-col>
          <v-row align="center">
            <v-col class="pb-0">
              <span :style="{ color: '#000000', fontSize: '18px' }">Notes</span>
            </v-col>
            <v-col v-if="item.id" class="text-end">
              <v-btn color="orange" outlined @click="openNoteForm">
                SEE ALL NOTES
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0">
              <v-textarea
                v-model="item.note"
                :disabled="(item.notes && item.notes.length > 0) || isView"
                outlined
                rows="3"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <part-pick-list-item-form
        ref="itemForm"
        :is-truck-schedule-request="true"
        @success="save"
      />
      <note-form v-show="false" ref="noteForm" />
      <confirm-form ref="confirmForm" />
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import PartPickListItemForm from '@/components/forms/partPickLists/PartPickListItemForm';
import NoteForm from '@/components/forms/notes/NoteForm';

export default {
  components: {
    PartPickListItemForm,
    NoteForm,
  },
  props: {
    isView: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    item: null,
    itemDto: {
      id: 0,
      inventory_class_id: null,
      project_id: null,
      department_id: null,
      items: [],
      is_active: 0,
      note: '',
    },
    headers: [
      { text: 'Item', value: 'inventory_tag_item.item_full_name', width: '40%' },
      { text: 'UOM', value: 'inventory_tag_item.uom.name', width: '5%' },
      { text: 'Qty on Hand', value: 'quantity_on_hand', width: '10%' },
      { text: 'Qty Required', value: 'quantity_required', width: '5%' },
      { text: 'Qty Supplied', value: 'quantity_supplied', width: '5%' },
      { text: 'Status', value: 'status', width: '10%', align: 'center' },
      {
        text: 'Actions',
        value: 'actions',
        align: 'end',
        width: '10%',
      },
    ],
    qrCodes: [],
    loading: false,
    inventoryClassIdInst: 4,
    noteTypeIdPickList: 6,
  }),
  watch: {},
  computed: {
    ...mapState({
      user: (state) => state.user,
      isDarkMode: 'isDarkMode',
    }),
    isActive() {
      return this.item.is_active === 1;
    },
  },
  watch: {},
  created() {
    this.item = { ...this.itemDto };
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  methods: {
    async init() {
      await this.getQrCodes();
    },

    // async open(id, pickState = false) {
    //   this.pickState = pickState;
    //   this.item = { ...this.itemDto };
    //   this.item.items = [];
    //   this.$refs.dialogBox.open();
    //   this.$bus.$emit('loading');
    //   if (id) {
    //     this.item.id = id;
    //     const res = await this.get(id);
    //   }
    //   this.getProjects();
    //   this.getDepartments();
    //   this.$bus.$emit('loading');
    // },

    // async get(id) {
    //   if (!id) return;
    //   this.loading = true;
    //   this.item = { ...this.itemDto };
    //   const submitModel = {
    //     filters: {
    //       id,
    //       include_items: true,
    //     },
    //   };
    //   const res = await this.$api.partPickList.readData(submitModel);
    //   const cancelCode = 3001;
    //   if (res === cancelCode) { return; }
    //   this.loading = false;
    //   if (!res || !res.data) {
    //     this.item = { ...this.itemDto };
    //     return;
    //   }
    //   const firstIndex = 0;
    //   this.item = res.data[firstIndex];
    //   if (this.item.items.length > 0) {
    //     this.item.items.forEach((item, index) => {
    //       const inventoryTag = this.qrCodes.find((qrCode) => qrCode.inventory_tag === item.inventory_tag); // slow way
    //       item.quantity_on_hand = inventoryTag.quantity_on_hand;
    //       item.index = index;
    //       item.is_default = inventoryTag.item.departments && inventoryTag.item.departments.length > 0;
    //       item.inventory_tag_item = inventoryTag;
    //     });
    //   }
    // },

    async open(item) {
      this.$refs.dialogBox.open();
      this.loading = true;
      if (this.qrCodes.length === 0) {
        await this.getQrCodes();
      }
      if (item) {
        this.item = JSON.parse(JSON.stringify(item));
        if (this.item.items.length > 0) {
          this.item.items.forEach((item, index) => {
            const inventoryTag = this.qrCodes.find(
              (qrCode) => qrCode.inventory_tag === item.inventory_tag
            ); // slow way
            item.quantity_on_hand = inventoryTag.quantity_on_hand;
            item.index = index;
            item.is_default =
              inventoryTag.item.departments &&
              inventoryTag.item.departments.length > 0;
            item.inventory_tag_item = inventoryTag;
          });
        }
      } else {
        this.item = { ...this.itemDto };
        this.item.items = [];
      }
      this.loading = false;
    },

    async getQrCodes() {
      const readModel = {
        filters: {
          inventory_class_id: this.inventoryClassIdInst,
          is_qty_on_hand_o: 0,
        },
      };
      const res = await this.$api.inventoryTag.readData(readModel);

      const cancelCode = 3001;
      if (res === cancelCode) return;
      if (!res || !res.data || res.data.length === 0) {
        this.qrCodes = [];
        return;
      }
      this.qrCodes = res.data;
    },

    add() {
      this.$refs.itemForm.open(null, this.item.items.length, this.inventoryClassIdInst);
    },

    openEditItem(inventoryTag) {
      const itemIndex = this.item.items.findIndex(
        (x) => x.inventory_tag === inventoryTag
      );
      if (itemIndex < 0) return;
      this.$refs.itemForm.open(this.item.items[itemIndex], itemIndex, this.inventoryClassIdInst);
    },

    async submit() {
      if (this.item.items.length === 0) {
        this.$bus.$emit('showError', 'Please add at least one part.');
        return false;
      }
      // instead of creating a part pick list here, we will send the items to the parent (TruckScheduleRequestForm.vue)
      // and we will submit the part pick list when submitting the truck schedule request
      console.log(
        'this.item from installation form',
        JSON.parse(JSON.stringify(this.item))
      );
      this.$emit('success', JSON.parse(JSON.stringify(this.item)));
      this.$refs.dialogBox.close();
    },

    save(item, isShowError = true) {
      //when we edit the first item for some reason it pushes the item to the end of the list instead of editing it
      if (!item) return;
      // eslint-disable-next-line no-param-reassign
      const existingItemIndex = this.item.items.findIndex(
        (x) => x.inventory_tag === item.inventory_tag
      );
      if (existingItemIndex >= 0 && existingItemIndex !== item.index) {
        if (isShowError) this.$bus.$emit('showError', 'Item already exists.');
        return;
      }
      // check to see if we're editing an existing item's inventory_tag or quantity_required. If yes, then change status and quantity_supplied to null
      if (item.index < this.item.items.length) {
        const editItem = this.item.items[item.index];
        if (
          editItem.inventory_tag !== item.inventory_tag ||
          editItem.quantity_required !== item.quantity_required
        ) {
          item.status = null;
          item.quantity_supplied = null;
        }
      }
      if (item.index !== undefined && item.index !== null) {
        this.$set(
          this.item.items,
          item.index,
          JSON.parse(JSON.stringify(item))
        );
      } else {
        this.item.items.push(JSON.parse(JSON.stringify(item)));
      }
    },

    async deleteItem(item) {
      const confirm = await this.$refs.confirmForm.open({
        title: 'Are you sure that you want to delete this record?',
      });
      if (!confirm) return;
      const itemIndex = this.item.items.findIndex(
        (x) => x.inventory_tag === item.inventory_tag
      );
      if (itemIndex === -1) return;
      this.item.items.splice(itemIndex, 1);
    },

    openNoteForm() {
      this.$refs.noteForm.open(this.item.id, this.noteTypeIdPickList);
    },

    getQRCode(qrCode) {
      // eslint-disable-next-line eqeqeq
      const item = this.qrCodes.find((x) => x.inventory_tag == qrCode);
      if (!item) return '';
      return item.inventory_tag;
    },

    getItemName(qrCode) {
      // eslint-disable-next-line eqeqeq
      const item = this.qrCodes.find((x) => x.inventory_tag == qrCode);
      if (!item) return '';
      return item.item_full_name;
    },

    getTotalRequired() {
      let total = 0;
      this.item.items.forEach((item) => {
        if (item.quantity_required)
          total += parseInt(item.quantity_required, 10);
      });
      return total;
    },

    getTotalSupplied() {
      let total = 0;
      this.item.items.forEach((item) => {
        if (item.quantity_supplied) total += parseInt(item.quantity_supplied, 10);
      });
      return total;
    },
  },
};
</script>